(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3678],{

/***/ 93308:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/2026/summer",
      function () {
        return __webpack_require__(6105);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* reexport */ Accordion; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classcat/index.js
var classcat = __webpack_require__(83840);
// EXTERNAL MODULE: ./components/Accordion/accordion.module.sass
var accordion_module = __webpack_require__(38264);
var accordion_module_default = /*#__PURE__*/__webpack_require__.n(accordion_module);
;// CONCATENATED MODULE: ./components/Accordion/Accordion.jsx




var Accordion = function(param) {
    var key = param.key, children = param.children, title = param.title, isOpen = param.isOpen, onCloseExModal = param.onCloseExModal, actionOnClick = param.actionOnClick;
    var ref = (0,react.useState)(isOpen), isActive = ref[0], setIsActive = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (accordion_module_default()).accordion,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "accordion-item",
            itemScope: true,
            itemProp: "mainEntity",
            itemType: "https://schema.org/Question",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: (accordion_module_default()).accordionTitle,
                    onClick: function() {
                        setIsActive(!isActive);
                        if (onCloseExModal) {
                            onCloseExModal();
                        }
                        if (actionOnClick) {
                            actionOnClick();
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: (accordion_module_default()).innerTitle,
                            itemProp: "name",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: isActive ? (accordion_module_default()).open : (accordion_module_default()).close
                        }),
                        " "
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,classcat/* default */.Z)([
                        (accordion_module_default()).accordionContent,
                        isActive && (accordion_module_default()).accordionContentActive, 
                    ]),
                    itemScope: true,
                    itemProp: "acceptedAnswer",
                    itemType: "https://schema.org/Answer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        itemProp: "text",
                        children: children
                    })
                })
            ]
        })
    }, key);
};

;// CONCATENATED MODULE: ./components/Accordion/index.js



/***/ }),

/***/ 24277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ BreadCrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classcat/index.js
var classcat = __webpack_require__(83840);
// EXTERNAL MODULE: ./components/BreadCrumbs/breadCrumbs.module.sass
var breadCrumbs_module = __webpack_require__(75685);
var breadCrumbs_module_default = /*#__PURE__*/__webpack_require__.n(breadCrumbs_module);
// EXTERNAL MODULE: ./components/Icon/index.js + 1 modules
var Icon = __webpack_require__(85708);
// EXTERNAL MODULE: ./components/SpriteSVG/index.ts + 1 modules
var SpriteSVG = __webpack_require__(2708);
;// CONCATENATED MODULE: ./components/BreadCrumbs/BreadCrumbs.jsx







var BreadCrumbs = function(param) {
    var routeCrumbs = param.routeCrumbs, url = param.url;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (breadCrumbs_module_default()).wrapper,
        itemScope: true,
        itemType: "https://schema.org/BreadcrumbList",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (breadCrumbs_module_default()).overflowWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (breadCrumbs_module_default()).crumb,
                    href: "/",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        itemProp: "name",
                        className: (0,classcat/* default */.Z)([
                            (breadCrumbs_module_default()).home,
                            (0,_define_property/* default */.Z)({}, (breadCrumbs_module_default()).homeBf, url === "black_friday"), 
                        ]),
                        children: url === "black_friday" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                name: "common/bfHomePage",
                                width: 10,
                                height: 10
                            }),
                            itemProp: "item"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                name: "common/HomePage",
                                width: 16,
                                height: 16
                            }),
                            itemProp: "item"
                        })
                    })
                }),
                routeCrumbs.map(function(i, id) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        itemProp: "itemListElement",
                        itemScope: true,
                        itemType: "https://schema.org/ListItem",
                        className: (breadCrumbs_module_default()).point,
                        children: url === "black_friday" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            itemProp: "item",
                            href: i.link,
                            className: (breadCrumbs_module_default()).crumb,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    itemProp: "name",
                                    className: id === routeCrumbs.length - 1 ? (breadCrumbs_module_default()).currentBf : (breadCrumbs_module_default()).activeBf,
                                    children: i.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    itemProp: "position",
                                    content: id + 1
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            itemProp: "item",
                            href: i.link,
                            className: (breadCrumbs_module_default()).crumb,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    itemProp: "name",
                                    className: id === routeCrumbs.length - 1 ? (breadCrumbs_module_default()).current : (breadCrumbs_module_default()).active,
                                    children: i.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    itemProp: "position",
                                    content: id + 1
                                })
                            ]
                        })
                    }, id);
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/BreadCrumbs/index.js



/***/ }),

/***/ 63145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* reexport */ Collapsed; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/interweave/esm/index.js
var esm = __webpack_require__(63108);
// EXTERNAL MODULE: ./components/Accordion/index.js + 1 modules
var Accordion = __webpack_require__(59166);
// EXTERNAL MODULE: ./components/Button/index.js + 1 modules
var Button = __webpack_require__(11866);
// EXTERNAL MODULE: ./lib/YaAndGaHelper.js + 2 modules
var YaAndGaHelper = __webpack_require__(38214);
;// CONCATENATED MODULE: ./components/Collapsed/Collapsed.jsx









/**
 * Компонент для скрытия контента
 * Переписать на нормальный компонент
 */ var Collapsed = function(_param) {
    var items = _param.items, isOpen = _param.isOpen, shorter = _param.shorter, isResult = _param.isResult, isCruis = _param.isCruis, isSeo = _param.isSeo, seo = _param.seo, isPickCaute = _param.isPickCaute, onCloseExModal = _param.onCloseExModal, onClickAction = _param.onClickAction, targets = _param.targets, props = (0,_object_without_properties/* default */.Z)(_param, [
        "items",
        "isOpen",
        "shorter",
        "isResult",
        "isCruis",
        "isSeo",
        "seo",
        "isPickCaute",
        "onCloseExModal",
        "onClickAction",
        "targets"
    ]);
    var ref;
    var ref1 = (0,react.useState)(3), count = ref1[0], setCount = ref1[1];
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isSeo && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: seo.map(function(param) {
                    var title = param.title, description = param.description;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* Accordion */.U, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        isOpen: isOpen,
                        title: title
                    }, props), {
                        children: description
                    }));
                })
            }),
            isResult ? items === null || items === void 0 ? void 0 : items.map(function(i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* Accordion */.U, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    isOpen: isOpen,
                    title: i.title
                }, props), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.ZP, {
                        content: "".concat(i.body.text)
                    })
                }), i.title);
            }).slice(0, shorter ? count : items.length) : (ref2 = (ref = items === null || items === void 0 ? void 0 : items.slice(0, shorter ? count : items.length)) === null || ref === void 0 ? void 0 : ref.map(function(i) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Accordion/* Accordion */.U, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    isOpen: isOpen,
                    title: isSeo ? i === null || i === void 0 ? void 0 : i.caption : i === null || i === void 0 ? void 0 : i.title,
                    onCloseExModal: onCloseExModal,
                    actionOnClick: function() {
                        if (i.target) {
                            (0,YaAndGaHelper/* YaAndGaCruisePage */.uX)([
                                i.target
                            ]);
                        }
                    }
                }, props), {
                    children: !isCruis ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.ZP, {
                        content: "".concat(!isPickCaute ? i.body : i === null || i === void 0 ? void 0 : i.desc)
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: i.body
                    })
                }), i === null || i === void 0 ? void 0 : i.title);
            })) !== null && ref2 !== void 0 ? ref2 : [].slice(0, shorter ? count : items.length),
            shorter && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: count < (items === null || items === void 0 ? void 0 : items.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    onClick: function() {
                        setCount(count + 3);
                        (0,YaAndGaHelper/* YaAndGaCruisePage */.uX)(onClickAction);
                    },
                    children: "Загрузить ещё вопросы"
                })
            })
        ]
    });
};
Collapsed.defaultProps = {
    isOpen: false,
    shorter: false
};

;// CONCATENATED MODULE: ./components/Collapsed/index.js



/***/ }),

/***/ 6105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ ResultPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2962);
/* harmony import */ var next_useragent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28010);
/* harmony import */ var _providers_RootStoreProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8710);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82913);
/* harmony import */ var _components_SearchPage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45692);
/* harmony import */ var _components_MainPage_Subscribe__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52755);
/* harmony import */ var _providers_SearchStoreProvider__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27101);
/* harmony import */ var _components_Collapsed__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(63145);
/* harmony import */ var _utils_seo__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(13553);
/* harmony import */ var _components_BreadCrumbs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(24277);












var __N_SSP = true;
function ResultPage(param) {
    var uaString = param.uaString, _store = param.store, popdir = _store.popdir, url = _store.url, user = _store.user, seoRaw = _store.seoRaw, banners = _store.banners, popularPopdirs = _store.popularPopdirs, canonicalUrl = param.canonicalUrl;
    var ua = (0,next_useragent__WEBPACK_IMPORTED_MODULE_3__/* .useUserAgent */ .FS)(uaString || window.navigator.userAgent);
    var isMobile = ua.isMobile, isTablet = ua.isTablet;
    var pageRoute = [
        {
            title: "Круизы на теплоходе 2026",
            link: "/2026"
        },
        {
            title: "Круизы на теплоходе летом",
            link: ""
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_providers_SearchStoreProvider__WEBPACK_IMPORTED_MODULE_8__/* .SearchStoreProvider */ .YG, {
        hydrationData: {
            popdir: popdir,
            url: url,
            user: user
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_providers_RootStoreProvider__WEBPACK_IMPORTED_MODULE_4__/* .RootStoreProvider */ .LD, {
            hydrationData: {
                popdir: popdir,
                url: url,
                user: user
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_2__/* .NextSeo */ .PB, {
                    title: (seoRaw === null || seoRaw === void 0 ? void 0 : seoRaw.seo_title.length) === 0 ? "Круизы на теплоходе летом 2026 года - расписание и цены" : seoRaw === null || seoRaw === void 0 ? void 0 : seoRaw.seo_title,
                    description: (seoRaw === null || seoRaw === void 0 ? void 0 : seoRaw.description.length) === 0 ? "Речные круизы летом 2026 на теплоходе. Онлайн-бронирование туров. Расписание на лето 2026 года. Описание маршрута, цены, выбор каюты. +7 499 681-10-19" : seoRaw === null || seoRaw === void 0 ? void 0 : seoRaw.description,
                    additionalLinkTags: [
                        {
                            rel: "shortcut icon",
                            href: "/favicon.ico?v=2"
                        }, 
                    ],
                    canonical: canonicalUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_5__/* .Layout */ .A, {
                    isMobile: isMobile,
                    isTablet: isTablet,
                    withoutForm: true,
                    popularPopdirs: popularPopdirs,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "container--block",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BreadCrumbs__WEBPACK_IMPORTED_MODULE_11__/* .BreadCrumbs */ .b, {
                                    routeCrumbs: pageRoute
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SearchPage__WEBPACK_IMPORTED_MODULE_6__/* .SearchPage */ .Z, {
                                noRedirectToResult: true,
                                url: url,
                                popdir: popdir,
                                isMobile: isMobile,
                                urlBanners: banners
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                                style: {
                                    marginTop: "24px"
                                },
                                children: (0,_utils_seo__WEBPACK_IMPORTED_MODULE_10__/* .hasSeo */ .rd)(seoRaw, popdir) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Collapsed__WEBPACK_IMPORTED_MODULE_9__/* .Collapsed */ .H, {
                                    seo: (0,_utils_seo__WEBPACK_IMPORTED_MODULE_10__/* .seoData */ .hD)(seoRaw),
                                    shorter: true,
                                    isSeo: true
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MainPage_Subscribe__WEBPACK_IMPORTED_MODULE_7__/* .Subscribe */ .x, {})
                        ]
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 13553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hD": function() { return /* binding */ seoData; },
/* harmony export */   "rd": function() { return /* binding */ hasSeo; }
/* harmony export */ });
/* unused harmony exports getSeoText, hasSeoCaption, hasSeoText */
/* harmony import */ var _serialize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27777);

var getSeoText = function(seo, popdir) {
    var seoText = seo === null || seo === void 0 ? void 0 : seo.seo_text;
    var popdirText = popdir === null || popdir === void 0 ? void 0 : popdir.seo_text_b2b;
    return seoText || popdirText;
};
var seoData = function(_seo, popdir) {
    return getSeoText(_seo, popdir).map(function(item, index) {
        return {
            title: _seo.seo_text_caption[index],
            description: (0,_serialize__WEBPACK_IMPORTED_MODULE_0__/* .serialize */ .q)(item.flat(Infinity))
        };
    });
};
var hasSeoCaption = function(_seo) {
    var ref;
    return !!(_seo === null || _seo === void 0 ? void 0 : (ref = _seo.seo_text_caption) === null || ref === void 0 ? void 0 : ref.filter(Boolean).length);
};
var hasSeoText = function(_seo, popdir) {
    return !!getSeoText(_seo, popdir);
};
var hasSeo = function(_seo, popdir) {
    return hasSeoCaption(_seo) && hasSeoText(_seo, popdir);
};


/***/ }),

/***/ 27777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ serialize; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var slate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77493);
/* harmony import */ var escape_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95573);
/* harmony import */ var escape_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(escape_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Image_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49028);





var serialize = function(children) {
    return children === null || children === void 0 ? void 0 : children.map(function(node, i) {
        if (node.type === "numbered-list") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                children: serialize(node.children)
            }, i);
        }
        if (slate__WEBPACK_IMPORTED_MODULE_4__/* .Text.isText */ .xv.isText(node)) {
            var text = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                dangerouslySetInnerHTML: {
                    __html: escape_html__WEBPACK_IMPORTED_MODULE_2___default()(node.text)
                }
            });
            if (node.bold) {
                text = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                    children: text
                }, i);
            }
            if (node.code) {
                text = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("code", {
                    children: text
                }, i);
            }
            if (node.italic) {
                text = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                    children: text
                }, i);
            }
            if (node.underline) {
                text = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    style: {
                        textDecoration: "underline"
                    },
                    children: text
                }, i);
            }
            if (node.strikethrough) {
                text = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    style: {
                        textDecoration: "line-through"
                    },
                    children: text
                }, i);
            }
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: text
            }, i);
        }
        if (!node) {
            return null;
        }
        switch(node.type){
            case "h1":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    children: serialize(node.children)
                }, i);
            case "h2":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    children: serialize(node.children)
                }, i);
            case "h3":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    children: serialize(node.children)
                }, i);
            case "h4":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                    children: serialize(node.children)
                }, i);
            case "h5":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                    children: serialize(node.children)
                }, i);
            case "h6":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                    children: serialize(node.children)
                }, i);
            case "blockquote":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("blockquote", {
                    children: serialize(node.children)
                }, i);
            case "ul":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    children: serialize(node.children)
                }, i);
            case "ol":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                    children: serialize(node.children)
                }, i);
            case "li":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    children: serialize(node.children)
                }, i);
            case "list-item":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    children: serialize(node.children)
                }, i);
            case "heading-one":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    children: serialize(node.children)
                }, i);
            case "heading-two":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    children: serialize(node.children)
                }, i);
            case "link":
                if (node.url.includes("youtube.com") || node.url.includes("https://vk.com/video")) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            height: "420px"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                            width: "100%",
                            title: "YouTube video player",
                            src: node.url,
                            allowFullScreen: true,
                            allow: "accelerometer",
                            referrerPolicy: "strict-origin-when-cross-origin"
                        })
                    });
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    href: escape_html__WEBPACK_IMPORTED_MODULE_2___default()(node.url),
                    rel: "noopener noreferrer",
                    style: {
                        color: "blue"
                    },
                    children: serialize(node.children)
                }, i);
            case "image":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Image_Image__WEBPACK_IMPORTED_MODULE_3__/* .Image */ .E, {
                    src: escape_html__WEBPACK_IMPORTED_MODULE_2___default()(node.url),
                    srcSet: escape_html__WEBPACK_IMPORTED_MODULE_2___default()(node.url),
                    alt: escape_html__WEBPACK_IMPORTED_MODULE_2___default()(node.alt),
                    title: escape_html__WEBPACK_IMPORTED_MODULE_2___default()(node.title),
                    loading: "lazy",
                    itemProp: "image"
                });
            default:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: serialize(node.children)
                }, i);
        }
    });
};


/***/ }),

/***/ 38264:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accordion":"accordion_accordion__Ww9nJ","accordionTitle":"accordion_accordionTitle__M2XG2","innerTitle":"accordion_innerTitle__wJIwd","accordionContent":"accordion_accordionContent__pVsW5","accordionContentActive":"accordion_accordionContentActive__Lnz13","close":"accordion_close__jwAf8","open":"accordion_open__FTLja"};

/***/ }),

/***/ 75685:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"breadCrumbs_wrapper__GujyW","overflowWrapper":"breadCrumbs_overflowWrapper__O0aFR","point":"breadCrumbs_point___AwGt","current":"breadCrumbs_current__uks0O","currentBf":"breadCrumbs_currentBf__aXcqk","active":"breadCrumbs_active__ExqTi","activeBf":"breadCrumbs_activeBf__8B_QV","crumb":"breadCrumbs_crumb__8cnCn","home":"breadCrumbs_home__ahfAn","homeBf":"breadCrumbs_homeBf__oorFp"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1272,718,3108,7499,3215,1390,9774,2888,179], function() { return __webpack_exec__(93308); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);